var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isOfTypeObject = function isOfTypeObject(val) {
  return (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
};

export default isOfTypeObject;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/internal/isOfTypeObject.js
// module id = 357
// module chunks = 0